import i18n from "../../../../services/i18n";

export const getFilteredOption = (options: any[], selectedOption?: any) => {
  const rootDir = { id: "root", friendly_name: i18n.t("transfer_modal.root") };
  const updatedOptions = options.filter((option) => option.value === null);
  return [rootDir, ...updatedOptions];
};
